import { render, staticRenderFns } from "./ContactPersonForm.vue?vue&type=template&id=c957a9e4"
import script from "./ContactPersonForm.vue?vue&type=script&lang=js"
export * from "./ContactPersonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports